import { render, staticRenderFns } from "./AppointmentSettingActive.vue?vue&type=template&id=c6431316"
import script from "./AppointmentSettingActive.vue?vue&type=script&lang=js"
export * from "./AppointmentSettingActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports